<template>
  <ul class="list-group list-group-flush">


    <!--iChoosr (bundled pricing) excluding VAT -->
    <template v-if="useBundlePricing">
      <div class="list-group-item" style="border-top: 0">
        <price-item
          :dc="{ key: 'pv_price_bundle_price' }"
          :price="quote.detailOverview.contractPriceExclVATBeforeDiscountWithoutAdders"
        />
      </div>

      <!-- IChoosr extra work --> 
      <div class="list-group-item" v-if="quote.adders.length">
        <h5 class="font-weight-bold" v-dynamic-content:pv_bundled_price_adders_title></h5>

        <ul class="checks list-unstyled">
          <li v-for="(adder, index) in quote.adders" :key="index">{{ pickProductName(adder) }}</li>
        </ul>
        <price-item
          :dc="{ key: 'pv_bundled_price_adders_price' }"
          :price="quote.detailOverview.addersOnlyExclVATBeforeDiscount"
        />
      </div>

    </template>

   
    <!-- Regular / TRS price excluding VAT-->
    <template v-else> 
      <div class="list-group-item">
        <price-item v-if="trsMode" 
          :dc="{ key: 'net_investment' }" 
          :price="trsPriceRangeExclVat" />

        <price-item v-else
          :dc="{ key: 'pv_system_price_excl_vat' }"
          :price="detailOverview.contractPriceExclVATBeforeDiscount"
        />
      </div>
    </template>


    <!-- taxes --> 
    <div class="list-group-item">
      <price-item
        :dc="{ key: 'pv_system_vat_title' }"
        :price="trsMode ? 0 : detailOverview.valueAddedTaxBeforeDiscount"
      />

      <template v-if="!trsMode">
        <price-item v-if="detailOverview.nonTaxableSubtotalBeforeDiscount > 0"
          :dc="{ key: 'pv_system_vat_percentage_of_subtotal', substitutions: [
            $options.filters.formatPercentage(0),
            $options.filters.formatCurrency(detailOverview.nonTaxableSubtotalBeforeDiscount)
          ]}"
          :price="0"
          class="ml-md-8 mb-0"
        />

        <price-item v-if="detailOverview.taxableSubtotalExclVATBeforeDiscount > 0"
          :dc="{ key: 'pv_system_vat_percentage_of_subtotal', substitutions: [
            $options.filters.formatPercentage(detailOverview.valueAddedTaxTariffPercentage),
            $options.filters.formatCurrency(detailOverview.taxableSubtotalExclVATBeforeDiscount)
          ]}"
          :price="detailOverview.valueAddedTaxBeforeDiscount"
          class="ml-md-8 mb-0"
        />
      </template>

    </div>


    <!-- discount -->
    <div class="list-group-item" v-if="showDiscount && !trsMode">
      <price-item
        :dc="{ key: 'pv_system_price_before_discount' }"
        :price="detailOverview.contractPriceBeforeDiscount"
      />
      <price-item
        :dc="{ key: 'pv_price_discount' }"
        :price="detailOverview.discount"
        class="ml-md-8 mb-0"
      />
    </div>


    <!-- Totals -->
    <div class="list-group-item">
      <price-item
        v-if="trsMode"
        :isTotals="true"
        :dc="{ key: 'pv_price_total' }"
        :price="trsTotalsRange"
        :textMuted="{ key: 'indicative_amounts' }"
      />

      <price-item
        v-else
        :isTotals="true"
        :dc="{ key: 'pv_price_total' }"
        :price="detailOverview.contractPrice"
      />
    </div>

    <div
      class="list-group-item"
      v-if="
        content.pv_price_disclaimer_shorttext &&
        content.pv_price_disclaimer_shorttext !== 'OFF' &&
        !isGeneric
      "
    >
      <p
        class="font-size-sm mb-1 summary-price-disclaimer"
        v-dynamic-content:pv_price_disclaimer_shorttext
      ></p>
      <a class="info-symbol" role="button" data-info-popup="price-disclaimer"></a>
    </div>
  </ul>
</template>

<script>
import PriceItem from '@/components/quotes/DetailListPriceBlockItem'
import { mapGetters } from 'vuex'

export default {
  props: ['quote'],
  name: 'DetailListPriceBlock',
  mixins: ['pickProductName'],
  components: { PriceItem },
  computed: {
    ...mapGetters(['quoteType', 'isGeneric', 'isIChoosr']),

    useBundlePricing() {
      return this.isIChoosr
    },
    detailOverview() {
      return this.quote.detailOverview
    },
    showDiscount() {
      return this.detailOverview.discount !== 0
    },
    showPriceExVAT() {
      return !this.isGeneric && this.detailOverview.contractPriceExclVAT
    },
    valueAddedTaxTariffPercentage() {
      return this.$options.filters.formatPercentage(
        this.detailOverview.valueAddedTaxTariffPercentage
      )
    },
    trsPriceRangeExclVat() {
      return [
        this.detailOverview.contractPriceRangeExcVAT.start,
        this.detailOverview.contractPriceRangeExcVAT.end,
      ]
    },

    trsTotalsRange() {
      return [
        this.detailOverview.contractPriceRange.start,
        this.detailOverview.contractPriceRange.end,
      ]
    },
  },
}
</script>

<style scoped>
h5 {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
}
ul.checks {
  margin-bottom: 1rem;
}
</style>
